export const categories = [
  "Tous",
  "Entretien",
  "Taille de haies",
  "Pelouses",
  "Aménagement",
  "Nettoyage",
  "Création de jardins",
];

export const realisations = [
  {
    id: 1,
    category: "Entretien",
    title: "Entretien régulier d'un jardin d'agrément",
    image:
      "https://images.unsplash.com/photo-1641317430847-243b44c07125?crop=entropy&cs=srgb&fm=jpg&q=80",
  },
  {
    id: 2,
    category: "Taille de haies",
    title: "Taille architecturée d'une allée de buis",
    image:
      "https://images.unsplash.com/photo-1731492389170-249e3356950d?crop=entropy&cs=srgb&fm=jpg&q=80",
  },
  {
    id: 3,
    category: "Pelouses",
    title: "Pelouse dense et fraîchement tondue",
    image:
      "https://images.unsplash.com/photo-1662559459212-d9cbe0276702?crop=entropy&cs=srgb&fm=jpg&q=80",
  },
  {
    id: 4,
    category: "Aménagement",
    title: "Allée minérale et banc d'agrément",
    image:
      "https://images.unsplash.com/photo-1622322894637-2b5a02a1c1e4?crop=entropy&cs=srgb&fm=jpg&q=80",
  },
  {
    id: 5,
    category: "Nettoyage",
    title: "Remise en état d'une allée pavée",
    image:
      "https://images.pexels.com/photos/10772470/pexels-photo-10772470.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: 6,
    category: "Création de jardins",
    title: "Création d'une pergola plantée",
    image:
      "https://images.unsplash.com/photo-1563714193017-5a5fb60bc02b?crop=entropy&cs=srgb&fm=jpg&q=80",
  },
  {
    id: 7,
    category: "Entretien",
    title: "Massifs fleuris suivis toute la saison",
    image:
      "https://images.unsplash.com/photo-1728066909157-b9697e3822d2?crop=entropy&cs=srgb&fm=jpg&q=80",
  },
  {
    id: 8,
    category: "Taille de haies",
    title: "Élagage et taille de haie à la barre",
    image:
      "https://images.unsplash.com/photo-1788610830488-1343095c571c?crop=entropy&cs=srgb&fm=jpg&q=80",
  },
  {
    id: 9,
    category: "Pelouses",
    title: "Tonte de pelouse sur grande surface",
    image:
      "https://images.unsplash.com/photo-1748893790747-fc2646924cbe?crop=entropy&cs=srgb&fm=jpg&q=80",
  },
  {
    id: 10,
    category: "Aménagement",
    title: "Cheminement curvy au cœur des floraisons",
    image:
      "https://images.unsplash.com/photo-1692339699736-acb2a3a06b58?crop=entropy&cs=srgb&fm=jpg&q=80",
  },
  {
    id: 11,
    category: "Création de jardins",
    title: "Patio végétal intégré",
    image:
      "https://images.unsplash.com/photo-1633330948542-0b3bdeefcdb3?crop=entropy&cs=srgb&fm=jpg&q=80",
  },
  {
    id: 12,
    category: "Nettoyage",
    title: "Débroussaillage et nettoyage d'abords",
    image:
      "https://images.unsplash.com/photo-1669212300339-601b4a88b81a?crop=entropy&cs=srgb&fm=jpg&q=80",
  },
];

// Exemples avant / après — photos de démonstration à remplacer par les
// vraies photos des chantiers d'Embèk Group.
export const beforeAfter = [
  {
    id: 1,
    category: "Entretien",
    title: "Remise en état d'un jardin laissé à l'abandon",
    before:
      "https://images.unsplash.com/photo-1669212300339-601b4a88b81a?crop=entropy&cs=srgb&fm=jpg&q=80",
    after:
      "https://images.pexels.com/photos/34861784/pexels-photo-34861784.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: 2,
    category: "Création de jardins",
    title: "Création de massifs et mise en valeur des abords",
    before:
      "https://images.unsplash.com/photo-1596086221164-c8a4cac55e27?crop=entropy&cs=srgb&fm=jpg&q=80",
    after:
      "https://images.unsplash.com/photo-1597201278257-3687be27d954?crop=entropy&cs=srgb&fm=jpg&q=80",
  },
];

export const heroImage =
  "https://images.unsplash.com/photo-1624301269612-805e48c4d3da?crop=entropy&cs=srgb&fm=jpg&q=80";

export const aboutImage =
  "https://images.unsplash.com/photo-1617576683096-00fc8eecb3af?crop=entropy&cs=srgb&fm=jpg&q=80";

export const aboutImageAlt =
  "https://images.unsplash.com/photo-1641317430847-243b44c07125?crop=entropy&cs=srgb&fm=jpg&q=80";

export const ctaImage =
  "https://images.unsplash.com/photo-1734079692147-c6fc9438a2d0?crop=entropy&cs=srgb&fm=jpg&q=80";
